<div  class="management-attributes-header-content flex-start flex-col" >
    <table *ngIf="name || tag || type" class="header-table">
        <tr>
            <td class="label">Name: </td>
            <td>
                <h4 class="name">{{ name }}</h4>
            </td>
            <td>
                <strong
                    [attr.data-testid]="'disabled-text'"
                    class="disabled-source"
                    *ngIf="disabledSource"
                >
                    {{ disabledSource }}
                </strong>
            </td>
        </tr>
        <tr *ngIf="tag">
            <td class="label">Tag: </td>
            <td>
                <h4 class="header-info" [attr.title]="tag"> {{ tag }}</h4>
            </td>
        </tr>
        <tr *ngIf="type">
            <td class="label">Type: </td>
            <td>
                <h4 class="header-info" [attr.type]="type"> {{ type }}</h4>
            </td>
            <td>
                <emm-locales-select
                    class="locale-selector"
                    *ngIf="(selectedScreen$ | async).route === 'items' || (selectedScreen$ | async).route === 'item-groupings'"
                ></emm-locales-select>
            </td>
        </tr>
        <tr *ngIf="description">
            <td>
                <span class="label">Description: </span>
            </td>
            <td>
                <span class="description-value">{{ description }}</span>
            </td>
        </tr>
    </table>
</div>
